import React, { FC, ReactElement, useEffect, useMemo, useState } from 'react';
import styles from './HashtagDetails.module.scss';
import { path } from 'app/utils/path';
import {
  LanguageIcon,
  HashtagIcon,
  TrendingIcon,
  UserNetworkIcon,
  UserIcon,
  ViewICon,
  InstagramBigIcon,
  LinkedinBigIcon,
  YoutubeIcon,
  VideoIcon,
  VideoBigIcon,
  SummaryPosts,
  TotalInf,
  TweetType,
} from 'app/assets/images/icons';
import MostFrequentCard from 'app/components/MostFrequentCard';
import IconCard from 'app/components/IconCard';
import { Grid } from '@material-ui/core';
import DonutChart from 'app/components/Charts/DonutChart';
import SecondaryTable from 'app/components/Tables/SecondaryTable';
import { _t } from 'app/utils/i18n';
import DotsMap from 'app/components/DotsMap';
import {
  apiRoutes,
  apiRoutes as hashtagsApiRoutes,
} from 'hashtags/utils/apiRoutes';
import { Link, useHistory } from 'react-router-dom';
import { nFormatter } from 'app/utils/numbersFormater';
import { dateTimeFormatter } from 'app/utils/dateTimeFormatter';
import {
  fetchRealtedHashtages,
  fetchFirstMention,
  fetchTopCountries,
  fetchTopLanguages,
  fetchFrequentWords,
  getInstagramTopLanguage,
  getLinkedinTopLanguage,
  getFirstMention,
  getVideosTopLanguage,
  getTweetTopLanguage,
  getFirstMentionTwitter,
  getFirstMentionLinkedIn,
  getFirstMentionYoutube,
  getFirstMentionInstagram,
  getTypeOfTweetsMedia,
  getTiktokTopLanguage,
  getFirstMentionTiktok,
} from 'hashtags/Requests';
import CustomColumnChart from 'app/components/Charts/CustomColumnChart';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import TweetBoxForHashtags from 'app/components/TweetBoxForHashtags';
import ItemPopperCell from 'app/components/Tables/Cells/ItemPoperCell';
import ToolTipComp from 'app/components/ToolTipComp';
import {
  checkHoveringTranslated,
  checkTranslated,
  removeHash,
} from 'app/utils/helpers';
import CardTitle from 'app/components/CardTitle';
import PopperComponent from 'app/components/Tables/Cells/PopperComponent';
import TweetBox from 'app/components/TweetBox';
import { toast } from 'react-toastify';
import { useModal } from 'app/context/Modal';
import {
  navigateWithSearchState,
  savePrevSearchState,
} from 'app/utils/search-state';
import { storeInfluencerName } from 'influencers/Requests';
import ErrorBoundary from 'app/components/ErrorBoundary';
import { getFromLocalStorage } from 'app/utils/localStorage';
import AddComment from 'reports/components/AddComment';
import { useReport } from 'reports/pages/AddNewReport/AddNewReport';
import { getLowestCountry } from 'app/utils/getLowestCountry';
import { sortArrayFromRecentToOlder } from 'hashtags/utils/helpers';
import { extractTitleOrSubTileOrReportNameOrDesc } from 'reports/utils/utils';
import Loader from 'app/components/Loader';
import TwitterTweetCard from 'app/components/TwitterTweetCard';
import InstagramPostCard from 'app/components/InstagramPostCard';
import YouTubeVideoCard from 'app/components/YouTubeVideoCard';
import LinkedinPostCard from 'app/components/LinkedinPostCard';
import TiktokPostCard from 'app/components/TiktokPostCard';

interface IHashtagDetailsCharts {
  id: string;
  hashtag: any;
  reftechSentment: any;
  hashtagStatus: any;
  formattedFilters: any;
  hashtagError: any;
  isReport?: boolean;
  isTemplate?: boolean;
  isTrendingModule?: boolean;
  items?: any[];
  tabName?:
    | 'summary'
    | 'instagram'
    | 'linkedin'
    | 'youtube'
    | 'twitter'
    | 'tiktok';
  multiTabNames?: unknown[];
  isSample?: boolean;
}
const HashtagDetailsCharts: FC<IHashtagDetailsCharts> = ({
  id,
  hashtag,
  reftechSentment,
  hashtagStatus,
  formattedFilters,
  hashtagError,
  isReport,
  isTemplate,
  items,
  tabName,
  multiTabNames,
  isSample,
}) => {
  const currentHashtagId = {
    hashtag_id: +id,
    is_sample: isSample,
  };
  const [sentmentError] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [influencerName, setInfluencerName] = useState('');
  const history = useHistory();
  const queryClient = useQueryClient();
  const isTrendingModule = window?.location?.pathname?.includes('trends');
  const isEn = getFromLocalStorage('LNG') == 'en' ? true : false;
  const report = useReport();

  const {
    data: hashtagRelatedHashtags,
    isError: relatedHashtagsError,
    isLoading: hashtagLoading,
  } = useQuery(
    [
      'loadRelatedHashtags',
      {
        hashtag_id: currentHashtagId?.hashtag_id,
        is_sample: isSample,
        limit: 5,
      },
    ],
    fetchRealtedHashtages,
    {
      enabled: isTemplate
        ? !!items?.some(
            (item) => item.slug === 'hashtags_hashtag_view_related_hashtags',
          )
        : true,
    },
  );
  /*   const { data: hashtagFirstMention, isError: hashtagFirstMentionError } =
    useQuery(['loadFirstMention', currentHashtagId], fetchFirstMention, {
      enabled: isTemplate
        ? items?.some(
            (item) => item.slug === 'hashtags_hashtag_view_first_mention',
          )
        : true,
    }); */
  const { data: hashtagTopCountries, isError: hashtagTopCountriesError } =
    useQuery(['loadTopCountries', currentHashtagId], fetchTopCountries, {
      enabled:
        tabName === 'summary' ||
        items?.some(
          (item) => item.slug === 'hashtags_hashtag_view_tweets_world_map',
        ),
    });

  const { data: instagramTopLanguages, isError: instagramTopLanguageError } =
    useQuery(
      ['loadTopLanguagesInstagram', currentHashtagId],
      getInstagramTopLanguage,
      {
        enabled:
          tabName === 'instagram' ||
          !!items?.some(
            (item) =>
              item.slug ===
              'hashtags_hashtag_view_instagram_posts_top_languages',
          ),
        cacheTime: 0,
        staleTime: 0,
      },
    );
  const { data: typeOfTweetsMedia, isError: typeOfTweetsMediaError } = useQuery(
    ['typeOfTweetsMedia', currentHashtagId],
    getTypeOfTweetsMedia,
    {
      enabled:
        tabName === 'twitter' ||
        !!items?.some(
          (item) =>
            item.slug === 'hashtags_hashtag_view_tweets_type_of_tweets_media',
        ),
      cacheTime: 0,
      staleTime: 0,
    },
  );
  const notHasTweetMedia = typeOfTweetsMedia
    ? typeOfTweetsMedia?.values
        ?.map((val: any) => val?.data?.every((i: number) => i === 0))
        ?.every((item: boolean) => item === true)
    : undefined;

  const { data: tweetTopLanguages, isError: tweetTopLanguageError } = useQuery(
    ['loadTopLanguagesTweets', currentHashtagId],
    getTweetTopLanguage,
    {
      enabled:
        tabName === 'twitter' ||
        !!items?.some(
          (item) => item.slug === 'hashtags_hashtag_view_tweets_top_languages',
        ),
      cacheTime: 0,
      staleTime: 0,
    },
  );
  const { data: linkedinTopLanguages, isError: linkedinTopLanguageError } =
    useQuery(
      ['loadTopLanguagesLinkedin', currentHashtagId],
      getLinkedinTopLanguage,
      {
        enabled:
          tabName === 'linkedin' ||
          !!items?.some(
            (item) =>
              item.slug ===
              'hashtags_hashtag_view_linkedin_posts_top_languages',
          ),
        cacheTime: 0,
        staleTime: 0,
      },
    );
  const { data: videosTopLanguages, isError: videosTopLanguageError } =
    useQuery(
      ['loadTopLanguagesVideos', currentHashtagId],
      getVideosTopLanguage,
      {
        enabled:
          tabName === 'youtube' ||
          !!items?.some(
            (item) =>
              item.slug ===
              'hashtags_hashtag_view_youtube_videos_top_languages',
          ),
        cacheTime: 0,
        staleTime: 0,
      },
    );
  const { data: tiktokTopLanguages, isError: tiktokTopLanguageError } =
    useQuery(['getTiktokTopLanguage', currentHashtagId], getTiktokTopLanguage, {
      enabled:
        tabName === 'tiktok' ||
        !!items?.some(
          (item) =>
            item.slug === 'hashtags_hashtag_view_tiktok_videos_top_languages',
        ),
      cacheTime: 0,
      staleTime: 0,
    });
  const { data: hashtagFrequenWord, isError: hashtagFrequenWordError } =
    useQuery(['loadFrequenWord', currentHashtagId], fetchFrequentWords, {
      enabled:
        tabName === 'summary' ||
        !!items?.some(
          (item) => item.slug === 'hashtags_hashtag_view_most_frequent_words',
        ),
    });

  const modal = useModal();
  const { mutateAsync: addInfluncerNameMutateAsync } = useMutation(
    storeInfluencerName,
    {
      onSuccess: (data: any) => {
        modal.hide();
        history.push(
          `${path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI}/${data?.id}`,
        );
        toast.success(<span>{_t('influencers:added_influencer')}</span>);
      },
      onError: (err: any) => {
        modal.hide();
        err?.response?.status === 401
          ? modal.show({
              isAlternative: true,
              message: err?.response?.data?.message,
            })
          : toast.error(<span>{err?.response?.data?.message}</span>);
      },
    },
  );

  const {
    data: firstMentionData,
    isError: firstMentionError,
    isLoading,
  } = useQuery(
    [
      'getFirstMention',
      { hashtag_id: +id, is_sample: isSample },
      tabName === 'linkedin',
      tabName === 'youtube',
      tabName === 'twitter',
      tabName === 'tiktok',
      tabName === 'instagram',
    ],
    getFirstMention,
    {
      enabled:
        tabName === 'instagram' ||
        tabName === 'linkedin' ||
        tabName === 'youtube' ||
        tabName === 'tiktok' ||
        tabName === 'twitter',
      cacheTime: 0,
      staleTime: 0,
    },
  );

  const {
    data: firstMentionDataTwitter,
    isError: firstMentionErrorTwitter,
    isLoading: isLoadingTwitter,
  } = useQuery(
    [`getFirstMentionTwitter`, currentHashtagId],
    getFirstMentionTwitter,
    {
      cacheTime: 0,
      staleTime: 0,
      enabled:
        !!multiTabNames?.includes('twitter') &&
        !!items?.some(
          (item) => item.slug === 'hashtags_hashtag_view_tweets_first_mention',
        ),
    },
  );
  const {
    data: firstMentionDataLinkedIn,
    isError: firstMentionErrorLinkedIn,
    isLoading: isLoadingLinkedIn,
  } = useQuery(
    [`getFirstMentionLinkedIn`, currentHashtagId],
    getFirstMentionLinkedIn,
    {
      cacheTime: 0,
      staleTime: 0,
      enabled:
        !!multiTabNames?.includes('linkedin') &&
        !!items?.some(
          (item) =>
            item.slug === 'hashtags_hashtag_view_linkedin_posts_first_mention',
        ),
    },
  );

  const {
    data: firstMentionDataYoutube,
    isError: firstMentionErrorYoutube,
    isLoading: isLoadingYoutube,
  } = useQuery(
    [`getFirstMentionYoutube`, currentHashtagId],
    getFirstMentionYoutube,
    {
      cacheTime: 0,
      staleTime: 0,
      enabled:
        !!multiTabNames?.includes('youtube') &&
        !!items?.some(
          (item) =>
            item.slug === 'hashtags_hashtag_view_youtube_videos_first_mention',
        ),
    },
  );

  const {
    data: firstMentionDataTiktok,
    isError: firstMentionErrorTiktok,
    isLoading: isLoadingTiktok,
  } = useQuery(
    [`getFirstMentionTiktok`, currentHashtagId],
    getFirstMentionTiktok,
    {
      cacheTime: 0,
      staleTime: 0,
      enabled:
        !!multiTabNames?.includes('tiktok') &&
        !!items?.some(
          (item) =>
            item.slug === 'hashtags_hashtag_view_tiktok_videos_first_mention',
        ),
    },
  );

  const {
    data: firstMentionDataInstagram,
    isError: firstMentionErrorInstagram,
    isLoading: isLoadingInstagram,
  } = useQuery(
    [`getFirstMentionInstagram`, currentHashtagId],
    getFirstMentionInstagram,
    {
      cacheTime: 0,
      staleTime: 0,
      enabled:
        !!multiTabNames?.includes('instagram') &&
        !!items?.some(
          (item) =>
            item.slug === 'hashtags_hashtag_view_instagram_posts_first_mention',
        ),
    },
  );

  const addInfluncerNameAsUnanalyzed = async (name: string) => {
    const result = await addInfluncerNameMutateAsync({
      username: name,
    });
    return result;
  };
  const trendingListColumns = [
    {
      title: _t('hashtags:hashtags'),
      key: 'hashtag_name',
      render: (val: any, row: any) => (
        <p
          title={removeHash(
            checkHoveringTranslated(
              row.hashtag_name,
              row.hashtag_name_translated,
            ),
          )}
          dir="auto"
        >
          {checkTranslated(row.hashtag_name, row.hashtag_name_translated)}
        </p>
      ),
    },
    {
      title: _t('hashtags:trending_on'),
      key: 'trending_at',
      render: (value: string) => dateTimeFormatter.date(value, undefined, true),
    },
    {
      title: 'country',
      key: 'countries',
      render: (data: any) => (
        <ItemPopperCell
          data={data?.sort((a: any, b: any) => a.rank - b.rank)}
          headers={[_t('basic:countries'), _t('basic:rank')]}
          text={getLowestCountry(data)?.name || ''}
        />
      ),
    },
    {
      title: 'basic:translation',
      key: 'hashtag_name',
      render: (val: any, row: any) => (
        <>
          {row?.hashtag_name_translated?.length > 0 ? (
            <ToolTipComp
              title={removeHash(
                checkHoveringTranslated(
                  row.hashtag_name,
                  row.hashtag_name_translated,
                ),
              )}
            >
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> - </p>
          )}
        </>
      ),
    },
  ];
  const topCountriesColumns = [
    { title: _t('hashtags:country'), key: 'name' },
    {
      title: _t('hashtags:last_seen'),
      key: 'last_seen',
      render: (value: string) => dateTimeFormatter.distance(value),
    },
  ];

  const topMentionedImagesColumns = [
    {
      title: _t('hashtags:image'),
      key: 'label',
      render: (value: string) => (
        <>
          <div
            onClick={() => {
              modal.show({
                imageUrl: value,
              });
            }}
            className="truncate-text"
            style={{ cursor: 'pointer', width: '70%' }}
            dir="auto"
          >
            {value}
          </div>
        </>
      ),
    },
    {
      title: _t('hashtags:count'),
      key: 'value',
      render: (value: number) => nFormatter(value),
    },
  ];

  const relatedHashtagsColumns = [
    {
      title: _t('hashtags:hashtag'),
      key: 'hashtag_name',
      render: (val: any, row: any) => (
        <Link
          to={`${
            isTrendingModule
              ? path.trends.HASHTAG_VIEW_URI
              : path.hashtags.HASHTAG_VIEW_URI
          }/${row?.hashtag_id}/${savePrevSearchState(
            removeHash(
              checkTranslated(
                row?.hashtag_name?.original,
                row?.hashtag_name?.arabic,
              ),
            ),
          )}`}
          dir="auto"
          title={removeHash(
            checkHoveringTranslated(
              row?.hashtag_name?.original,
              row?.hashtag_name?.arabic,
            ),
          )}
        >
          {checkTranslated(
            row?.hashtag_name?.original,
            row?.hashtag_name?.arabic,
          )}
        </Link>
      ),
    },
    {
      title: _t('hashtags:mentions'),
      key: 'mentions_count',
      render: (data: any) => nFormatter(data),
    },
    {
      title: 'basic:translation',
      key: 'hashtag_name',
      render: (val: any, row: any) => (
        <>
          {row?.hashtag_name?.arabic?.length > 0 ? (
            <ToolTipComp
              title={removeHash(
                checkHoveringTranslated(
                  row?.hashtag_name?.original,
                  row?.hashtag_name?.arabic,
                ),
              )}
            >
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> - </p>
          )}
        </>
      ),
    },
  ];
  const hideCharts = isTemplate ? true : isReport && !isTemplate ? false : true;

  const influencersColumns = [
    {
      title: _t('hashtags:influencer_entity'),
      key: 'name',
      render: (val: any, row: any) =>
        row.id > 0 ? (
          <a
            className="cursor-pointer"
            onClick={() => handelInfOrEntityAuthorization(row)}
            title={checkTranslated(row?.name?.original, row?.name?.arabic)}
          >
            {checkTranslated(row?.name?.original, row?.name?.arabic)}
          </a>
        ) : (
          <p
            className="cursor-pointer "
            onClick={() => {
              openModalToAddinfluencer(row?.username),
                setInfluencerName(row?.name?.original);
            }}
          >
            {checkTranslated(row?.name?.original, row?.name?.arabic)}
          </p>
        ),
    },
    {
      title: _t('hashtags:followers'),
      key: 'followers',
      render: (item: any) => nFormatter(item),
    },
    // {
    //   title: 'basic:translation',
    //   key: 'name',
    //   render: (val: any, row: any) => (
    //     <>
    //       {row?.name?.arabic?.length > 0 ? (
    //         <ToolTipComp
    //           title={checkHoveringTranslated(
    //             row?.name?.original,
    //             row?.name?.arabic
    //           )}
    //         >
    //           <LanguageIcon />
    //         </ToolTipComp>
    //       ) : (
    //         <p> - </p>
    //       )}
    //     </>
    //   ),
    // },
  ];
  const topMentionedLinksColumns = [
    {
      title: _t('hashtags:the_link'),
      key: 'label',
      render: (value: string) => (
        <a href={value} target="_blank" rel="noreferrer">
          {value}
        </a>
      ),
    },
    {
      title: _t('hashtags:count'),
      key: 'value',
      render: (value: number) => nFormatter(value),
    },
  ];
  const handelInfOrEntityAuthorization = (data: any) => {
    modules.includes('INFLUENCERS') && !data?.is_entity
      ? history.push(
          `${
            data?.status === 'ANALYZED'
              ? path.influencers.ANALYZED_INFLUENCER_DETAILS_URI
              : path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI
          }/${data?.id}`,
        )
      : modules.includes('ENTITIES') && data?.is_entity
        ? history.push(
            `${
              data?.status === 'ANALYZED'
                ? path.entities.ANALYZED_ENTITIES_DETAILS_URI
                : path.entities.UN_ANALYZED_ENTITIES_DETAILS_URI
            }/${data?.id}`,
          )
        : modal.show({
            isAlternative: true,
            message: _t(`basic:you_are_not_authorize`),
          });
  };

  const ValuedTweetsColumns = [
    {
      title: _t('hashtags:tweet'),
      key: 'content',
      render: (val: any, row: any) => (
        <Link to={`${path.posts.TWITTER_POST_DETAILS_URI}/${row?.id}`}>
          {checkTranslated(row?.content?.original, row?.content?.arabic)}
        </Link>
      ),
    },
    {
      title: _t('hashtags:influencer_entity'),
      columnStyle: { width: 120 },
      key: 'influencer',
      render: (_: any, row: any) => (
        <>
          <ToolTipComp
            title={checkHoveringTranslated(
              row?.influencer?.name?.original,
              row?.influencer?.name?.arabic,
            )}
          >
            {row?.influencer?.influencer_id ? (
              <a
                className="cursor-pointer"
                onClick={() => handelInfAuthorization(row)}
              >
                {checkTranslated(
                  row?.influencer?.name?.original,
                  row?.influencer?.name?.arabic,
                )}
              </a>
            ) : (
              <p
                className="cursor-pointer "
                onClick={() => {
                  openModalToAddinfluencer(row?.username),
                    setInfluencerName(row?.username);
                }}
              >
                {row?.username}
              </p>
            )}
          </ToolTipComp>
        </>
      ),
    },
    {
      title: 'basic:view',
      key: 'content',
      columnStyle: { width: 80 },
      render: (val: any, row: any) => (
        <PopperComponent icon={<ViewICon />} compId="viewIconTooltip">
          <div style={{ maxWidth: '499px' }}>
            <TwitterTweetCard
              compId="hashtagView"
              isContentClickable
              data={row}
            />
          </div>
        </PopperComponent>
      ),
    },
    {
      title: 'basic:translation',
      columnStyle: { width: 80 },
      key: 'contant',
      render: (val: any, row: any) => (
        <>
          {row?.content?.arabic?.length > 0 ? (
            <ToolTipComp
              title={checkHoveringTranslated(
                row?.content?.original,
                row?.content?.arabic,
              )}
            >
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> - </p>
          )}
        </>
      ),
    },
  ];

  const RetweetColumns = [...ValuedTweetsColumns];

  RetweetColumns.splice(2, 0, {
    title: _t('hashtags:retweets_count'),
    columnStyle: { width: 100 },
    key: 'retweets_count',
    render: (_: any, row: any) => (
      <span>{nFormatter(row?.retweets_count)}</span>
    ),
  });

  const FavoritColumns = [...ValuedTweetsColumns];

  FavoritColumns.splice(2, 0, {
    title: _t('hashtags:likes_count'),
    columnStyle: { width: 100 },
    key: 'likes_count',
    render: (_: any, row: any) => <span>{nFormatter(row?.likes_count)}</span>,
  });

  const favouritPostColumns = [
    {
      title: _t('influencer:posts'),
      key: 'caption',
      render: (val: any, row: any) => (
        <Link to={`${path.posts.INSTAGRAM_POSTS_DETAILS_URI}/${row?.id}`}>
          {checkTranslated(row?.caption?.original, row?.caption?.arabic)}
        </Link>
      ),
    },
    FavoritColumns[1],
    {
      title: _t('basic:like'),
      key: 'likes_count',
      render: (val: any, row: any) => <div>{nFormatter(row?.likes_count)}</div>,
    },
    {
      title: 'basic:view',
      key: 'caption',
      columnStyle: { width: 80 },
      render: (val: any, row: any) => (
        <PopperComponent icon={<ViewICon />} compId="viewIconTooltip">
          <div style={{ maxWidth: '499px' }}>
            <InstagramPostCard
              isContentClickable
              data={row}
              compId="hashtagView"
            />
          </div>
        </PopperComponent>
      ),
    },
    FavoritColumns[4],
  ];
  const favouritvideosColumns = [
    {
      title: _t('basic:video'),
      key: 'title',
      render: (val: any, row: any) => (
        <Link to={`${path.posts.YOUTUBE_POST_DETAILS_URI}/${row.id}`}>
          {checkTranslated(row?.title?.original, row?.title?.arabic)}
        </Link>
      ),
    },
    FavoritColumns[1],
    {
      title: _t('basic:like'),
      key: 'likes_count',
      render: (val: any, row: any) => <div>{nFormatter(row?.likes_count)}</div>,
    },
    {
      title: 'basic:translation',
      columnStyle: { width: 80 },
      key: 'title',
      render: (val: any, row: any) => (
        <>
          {row?.title?.arabic?.length > 0 ||
          row?.content?.arabic?.length > 0 ? (
            <ToolTipComp
              title={checkHoveringTranslated(
                row?.title?.original || row?.content?.original,
                row?.title?.arabic || row?.content?.arabic,
              )}
            >
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> - </p>
          )}
        </>
      ),
    },
  ];
  const mostViewedVideoColumns = [...favouritvideosColumns];
  mostViewedVideoColumns.splice(2, 1, {
    title: 'basic:view',
    key: 'views_count',
    columnStyle: { width: 80 },
    render: (val: any, row: any) => <div>{nFormatter(row?.views_count)}</div>,
  });
  const tiktokMostViewedColumns = [...mostViewedVideoColumns];
  tiktokMostViewedColumns.splice(0, 1, {
    title: _t('basic:video'),
    key: 'content',
    render: (val: any, row: any) => (
      <Link to={`${path.posts.TIKTOK_POST_DETAILS_URI}/${row.id}`}>
        {checkTranslated(row?.content?.original, row?.content?.arabic)}
      </Link>
    ),
  });
  const tiktokFavoriteVideosColumns = [...favouritvideosColumns];
  tiktokFavoriteVideosColumns.splice(0, 1, {
    title: _t('basic:video'),
    key: 'content',
    render: (val: any, row: any) => (
      <Link to={`${path.posts.TIKTOK_POST_DETAILS_URI}/${row.id}`}>
        {checkTranslated(row?.content?.original, row?.content?.arabic)}
      </Link>
    ),
  });
  const engagedPostColumns = [
    {
      title: _t('influencer:posts'),
      key: 'post',
      render: (val: any, row: any) => (
        <div>{checkTranslated(row?.post?.original, row?.post?.arabic)}</div>
      ),
    },
    FavoritColumns[1],
    {
      title: _t('trends:engagement'),
      key: 'engagements',
      render: (val: any, row: any) => <div>{nFormatter(row?.engagements)}</div>,
    },
    {
      title: 'basic:view',
      key: 'content',
      columnStyle: { width: 80 },
      render: (val: any, row: any) => (
        <PopperComponent icon={<ViewICon />} compId="viewIconTooltip">
          <div style={{ maxWidth: '499px' }}>
            <LinkedinPostCard
              isContentClickable
              compId="hashtagView"
              data={row}
            />
          </div>
        </PopperComponent>
      ),
    },
    FavoritColumns[4],
  ];
  const modules: string[] =
    queryClient.getQueryData('getAuthorizedModules') || [];
  const handelInfAuthorization = (data: any) => {
    modules.includes('ENTITIES') &&
    data?.influencer?.is_entity &&
    !data?.influencer?.is_influencer
      ? history.push(
          `${path.entities.ANALYZED_ENTITIES_DETAILS_URI}/${data?.influencer?.influencer_id}`,
        )
      : modules.includes('INFLUENCERS') &&
          !data?.influencer?.is_entity &&
          data?.influencer?.is_influencer
        ? history.push(
            `${path.influencers.ANALYZED_INFLUENCER_DETAILS_URI}/${data?.influencer?.influencer_id}`,
          )
        : modules.includes('INFLUENCERS') &&
            !data?.influencer?.is_entity &&
            !data?.influencer?.is_influencer
          ? history.push(
              `${path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI}/${data?.influencer?.influencer_id}`,
            )
          : modal.show({
              isAlternative: true,
              message: _t(`basic:you_are_not_authorize`),
            });
  };

  const openModalToAddinfluencer = (name: string) => {
    modal.show({
      message: _t('hashtags:add_influencer_as_unanalyzes'),
      onOk: () => {
        addInfluncerNameAsUnanalyzed(name);
      },
      openLink: `https://twitter.com/${name}`,
      linkText: _t('hashtags:open_in_twitter'),
    });
  };
  const memoizedMentionsCustomFilters = useMemo(
    () => ({
      hashtag_id: +id,
      is_sample: isSample,
      ...formattedFilters,
      time_interval: isReport ? 'YEAR' : 'MONTH',
    }),
    [id, formattedFilters],
  );
  const memoizedTypeOFTweetsCustomFilters = useMemo(
    () => ({
      hashtag_id: +id,
      is_sample: isSample,
    }),
    [id],
  );

  const checkIsReport = (report: any, notReport: any = undefined) =>
    isReport && !isTemplate ? report : notReport;
  type TRenderCharts = { id: string; component: JSX.Element }[];

  const TotalChart = (props: {
    id: string;
    title: string;
    icon: ReactElement;
    slug?: string;
    count?: any;
  }) => {
    return {
      id: props.id,
      component: (
        <Grid
          lg={checkIsReport(6, 3)}
          md={12}
          item
          xl={checkIsReport(4, 2)}
          xs={checkIsReport(12, 6)}
        >
          <ErrorBoundary requiredApiCalls={[hashtagError]}>
            <IconCard
              title={props.title}
              withFilter
              hideInput
              cardData={{
                icon: props.icon,
                count: props.count,
              }}
              slug={props.slug}
              compId={props.id}
              hideIfNoData={hideCharts}
              additionalComponents={checkIsReport(
                <AddComment compId={props.id} id={id} {...report} />,
              )}
              isReport={isReport}
              customFilters={currentHashtagId}
            />
          </ErrorBoundary>
        </Grid>
      ),
    };
  };
  const sentimentChart = (props: {
    id: string;
    title: string;
    subTitle: string;
    slug: string;
  }) => {
    return {
      id: props.id,
      component:
        (hashtag?.analyzed && props.id) || isReport ? (
          <Grid
            item
            lg={checkIsReport(6, 3)}
            md={12}
            xl={checkIsReport(4, 2)}
            xs={12}
          >
            <ErrorBoundary>
              <DonutChart
                exportIcon
                slug={props.slug}
                customFilters={currentHashtagId}
                showFilter={!sentmentError}
                sentmentError
                donutTitle={props.title}
                title={props.subTitle}
                compId={props.id}
                refetchCounter={reftechSentment}
                additionalComponents={checkIsReport(
                  <AddComment compId={props.id} id={id} {...report} />,
                )}
                isReport={isReport}
              />
            </ErrorBoundary>
          </Grid>
        ) : (
          <></>
        ),
    };
  };
  const topLanguageChart = (props: {
    id: string;
    title: string;
    subTitle: string;
    topLanguages: any;
    topLanguagesError: any;
  }) => {
    return {
      id: props.id,
      component: props.topLanguages && (
        <Grid item lg={checkIsReport(6, 3)} md={12} xs={12}>
          <ErrorBoundary requiredApiCalls={[props.topLanguagesError]}>
            <DonutChart
              donutTitle={props.title}
              title={props.subTitle}
              data={props.topLanguages}
              compId={props.id}
              exportIcon
              dataFormatted
              hideIfNoData={hideCharts}
              additionalComponents={checkIsReport(
                <AddComment compId={props.id} id={id} {...report} />,
              )}
              isReport={isReport}
            />
          </ErrorBoundary>
        </Grid>
      ),
    };
  };
  const topInfluencerChart = (props: {
    id: string;
    title: string;
    slug: string;
  }) => {
    return {
      id: props.id,
      component: (
        <ErrorBoundary>
          <SecondaryTable
            tableCardTitle={props.title}
            hidePlatform
            hideFilters
            hideToggleView
            columns={influencersColumns}
            moduleName={props.slug}
            grid={{
              xs: 12,
              md: 12,
              lg: checkIsReport(12, 3),
              xl: checkIsReport(6, 3),
            }}
            customFilters={{
              limit: 5,
              hashtag_id: hashtag?.id,
              is_sample: isSample,
            }}
            compId={props.id}
            hideIfNoData={hideCharts}
            additionalComponents={checkIsReport(
              <AddComment compId={props.id} id={id} {...report} />,
            )}
            isReport={isReport}
          />
        </ErrorBoundary>
      ),
    };
  };

  const renderMentionsChart = (
    platform: string,
    props: Record<string, any>,
  ) => {
    if (platform === 'twitter')
      return (
        <TwitterTweetCard
          isReport={isReport}
          compId={props.id}
          isContentClickable
          data={props.firstMentionData}
        />
      );
    if (platform === 'instagram')
      return (
        <InstagramPostCard
          data={props.firstMentionData}
          isReport={isReport}
          compId={props.id}
          isContentClickable
        />
      );
    if (platform === 'youtube')
      return (
        <YouTubeVideoCard
          data={props.firstMentionData}
          isReport={isReport}
          compId={props.id}
          isContentClickable
        />
      );
    if (platform === 'linkedin')
      return (
        <LinkedinPostCard
          data={props.firstMentionData}
          isReport={isReport}
          compId={props.id}
          isContentClickable
        />
      );
    if (platform === 'tiktok')
      return (
        <TiktokPostCard
          data={props.firstMentionData}
          isReport={isReport}
          compId={props.id}
          withBigSize
          withoutSlider
          showFavorite
          isContentClickable
          detailsUrl={`${path.posts.TIKTOK_POST_DETAILS_URI}/${props.firstMentionData?.id}`}
        />
      );
  };

  const firstMentionChart = (props: {
    id: string;
    title: string;
    firstMentionError: any;
    firstMentionData: any;
    currentPlatform: string;
  }) => {
    return {
      id: props.id,
      component: props.firstMentionData?.id !== 0 && (
        <>
          <Grid item sm={12}>
            <CardTitle compId={props.id} title={props.title} />
          </Grid>
          <Grid
            id={props.id}
            item
            sm={12}
            style={{
              marginBottom: '1.5rem',
              padding: '1rem',
              background: 'var(--bgColor)',
              display: 'flex',
              justifyContent: 'center',
              margin: '0px 16px',
              minHeight: '200px',
              position: 'relative',
            }}
            className={styles.InfluencerDetails}
          >
            {isLoading ||
            isLoadingTwitter ||
            isLoadingLinkedIn ||
            isLoadingYoutube ||
            isLoadingTiktok ||
            isLoadingInstagram ? (
              <div style={{ position: 'absolute', top: '50%' }}>
                <Loader mediumSize />
              </div>
            ) : (
              <div style={{ width: '50%' }}>
                <ErrorBoundary requiredApiCalls={[props.firstMentionError]}>
                  {renderMentionsChart(props.currentPlatform, props)}
                </ErrorBoundary>
              </div>
            )}
          </Grid>
        </>
      ),
    };
  };
  const renderSecondaryTable = (props: {
    id: string;
    title: string;
    columns: any;
    slug: string;
    xlGrid?: number;
    lgGrid?: number;
  }) => {
    return {
      id: props.id,
      component: (
        <ErrorBoundary>
          <SecondaryTable
            tableCardTitle={props.title}
            hideFilters
            hideToggleView
            columns={props.columns}
            moduleName={props.slug}
            customFilters={{
              limit: 5,
              hashtag_id: hashtag?.id,
              is_sample: isSample,
            }}
            compId={props.id}
            hideIfNoData={hideCharts}
            grid={{
              xs: 12,
              md: 12,
              lg: checkIsReport(12, props.lgGrid ? props.lgGrid : 6),
              xl: checkIsReport(props.xlGrid ? props.xlGrid : 6),
            }}
            additionalComponents={checkIsReport(
              <AddComment compId={props.id} id={id} {...report} />,
            )}
            isReport={isReport}
          />
        </ErrorBoundary>
      ),
    };
  };
  const summary: TRenderCharts = [
    TotalChart({
      id: 'hashtags_hashtag_view_total_posts',
      title: _t('hashtags:total_posts'),
      icon: <SummaryPosts />,
      slug: apiRoutes().summaryTotalPosts,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_engagement',
      title: _t('trends:engagement'),
      icon: <TrendingIcon />,
      slug: apiRoutes().summaryEngagement,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_influencers_entities_count',
      title: _t('hashtags:influencers_entities'),
      icon: <TotalInf />,
      slug: apiRoutes().summaryInfluencersEntities,
    }),
    {
      id: 'hashtags_hashtag_view_top_languages',
      component: (
        <Grid
          item
          lg={checkIsReport(6, 3)}
          md={12}
          xl={checkIsReport(4, 3)}
          xs={12}
        >
          <ErrorBoundary>
            <DonutChart
              exportIcon
              slug={hashtagsApiRoutes().summaryTopLanguage}
              customFilters={{
                hashtag_id: +id,
                time_interval: 'DAY',
                is_sample: isSample,
              }}
              showFilter={!sentmentError}
              sentmentError
              donutTitle={_t('trends:Top_Languages')}
              title={_t('influencers:posts')}
              compId="hashtags_hashtag_view_top_languages"
              refetchCounter={reftechSentment}
              summarySentiment
              customTooltip
              additionalComponents={checkIsReport(
                <AddComment
                  compId="hashtags_hashtag_view_top_languages"
                  id={id}
                  {...report}
                />,
              )}
              isReport={isReport}
            />
          </ErrorBoundary>
        </Grid>
      ),
    },
    {
      id: 'hashtags_hashtag_view_related_hashtags',
      component: !!hashtagRelatedHashtags?.length ? (
        <Grid
          item
          lg={checkIsReport(12, 3)}
          md={12}
          xl={checkIsReport(6, 3)}
          xs={checkIsReport(12, 6)}
        >
          <ErrorBoundary requiredApiCalls={[relatedHashtagsError]}>
            <SecondaryTable
              tableCardTitle={_t('influencers:related_hashtags')}
              hideFilters
              hideToggleView
              columns={relatedHashtagsColumns}
              data={hashtagRelatedHashtags}
              compId="hashtags_hashtag_view_related_hashtags"
              hideIfNoData={hideCharts}
              additionalComponents={checkIsReport(
                <AddComment
                  compId="hashtags_hashtag_view_related_hashtags"
                  id={id}
                  {...report}
                />,
              )}
              isReport={isReport}
            />
          </ErrorBoundary>
        </Grid>
      ) : (
        <></>
      ),
    },
    {
      id: 'hashtags_hashtag_view_posts_type',
      component: (
        <Grid
          item
          lg={checkIsReport(6, 4)}
          md={12}
          xl={checkIsReport(4, 4)}
          xs={12}
        >
          <ErrorBoundary>
            <DonutChart
              exportIcon
              slug={hashtagsApiRoutes().summaryPostsType}
              customFilters={{
                hashtag_id: +id,
                time_interval: 'DAY',
                is_sample: isSample,
              }}
              showFilter={!sentmentError}
              sentmentError
              donutTitle={_t('influencers:posts_types')}
              title={_t('influencers:posts')}
              compId="hashtags_hashtag_view_posts_type"
              refetchCounter={reftechSentment}
              additionalComponents={checkIsReport(
                <AddComment
                  compId="hashtags_hashtag_view_posts_type"
                  id={id}
                  {...report}
                />,
              )}
              isReport={isReport}
            />
          </ErrorBoundary>
        </Grid>
      ),
    },
    {
      id: 'hashtags_hashtag_view_most_frequent_words',
      component: (
        <>
          {hashtagFrequenWord?.length > 0 && (
            <Grid item lg={checkIsReport(12, 6)} md={12} xs={12}>
              <ErrorBoundary requiredApiCalls={[hashtagFrequenWordError]}>
                <MostFrequentCard
                  title={_t('trends:Most_Frequent_Words')}
                  words={hashtagFrequenWord || []}
                  compId="hashtags_hashtag_view_most_frequent_words"
                  hideIfNoData={hideCharts}
                  withFreqNumber
                  additionalComponents={checkIsReport(
                    <AddComment
                      compId="hashtags_hashtag_view_most_frequent_words"
                      id={id}
                      {...report}
                    />,
                  )}
                  isReport={isReport}
                />
              </ErrorBoundary>
            </Grid>
          )}
        </>
      ),
    },

    {
      id: 'hashtags_hashtag_view_sentiment',
      component:
        (hashtag?.analyzed && tabName === 'summary') || isReport ? (
          <Grid
            item
            lg={checkIsReport(6, 3)}
            md={12}
            xl={checkIsReport(4, 2)}
            xs={12}
          >
            <ErrorBoundary>
              <DonutChart
                exportIcon
                slug={hashtagsApiRoutes().summarySentiment}
                customFilters={{
                  hashtag_id: +id,
                  time_interval: 'DAY',
                  is_sample: isSample,
                }}
                showFilter={!sentmentError}
                sentmentError
                donutTitle={_t('trends:sentiment')}
                title={_t('influencers:posts')}
                compId="hashtags_hashtag_view_sentiment"
                refetchCounter={reftechSentment}
                summarySentiment
                customTooltip
                additionalComponents={checkIsReport(
                  <AddComment
                    compId="hashtags_hashtag_view_sentiment"
                    id={id}
                    {...report}
                  />,
                )}
                isReport={isReport}
              />
            </ErrorBoundary>
          </Grid>
        ) : (
          <></>
        ),
    },
    {
      id: 'hashtags_hashtag_view_sentiment',
      component:
        !hashtag?.analyzed &&
        tabName === 'summary' &&
        !isTemplate &&
        !isSample ? (
          <Grid
            item
            lg={checkIsReport(6, 3)}
            md={12}
            xl={checkIsReport(4, 2)}
            xs={12}
          >
            <ErrorBoundary>
              <DonutChart
                exportIcon
                donutTitle={_t('trends:sentiment')}
                data={{
                  series: [1, 1, 1],
                  labels: [
                    _t('hashtags:negative'),
                    _t('hashtags:neutral'),
                    _t('hashtags:positive'),
                  ],
                }}
                title={_t('trends:tweets')}
                unAnalyzed
                compId="hashtags_hashtag_view_sentiment
              "
                additionalComponents={checkIsReport(
                  <AddComment
                    compId="hashtags_hashtag_view_sentiment
                  "
                    id={id}
                    {...report}
                  />,
                )}
                isReport={isReport}
              />
            </ErrorBoundary>
          </Grid>
        ) : (
          <></>
        ),
    },
  ];
  const twitter: TRenderCharts = [
    TotalChart({
      id: 'hashtags_hashtag_view_tweets_total_tweets',
      title: _t('trends:total_tweets'),
      icon: <TweetType />,
      count: hashtag?.grabbed_tweets_count,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_tweets_engagement',
      title: _t('trends:engagement'),
      icon: <TrendingIcon />,
      slug: apiRoutes().twitterEngagement,
    }),
    {
      id: 'hashtags_hashtag_view_tweets_total_mentions',
      component:
        hashtag?.is_trending || isReport ? (
          <Grid
            lg={checkIsReport(6, 3)}
            md={12}
            item
            xl={checkIsReport(4, 2)}
            xs={checkIsReport(12, 6)}
          >
            <ErrorBoundary requiredApiCalls={[hashtagError]}>
              <IconCard
                title={_t('trends:total_mentions')}
                withFilter
                hideInput
                cardData={{
                  icon: <HashtagIcon />,
                  count: hashtag?.mentions_count,
                }}
                compId={'hashtags_hashtag_view_tweets_total_mentions'}
                hideIfNoData={hideCharts}
                additionalComponents={checkIsReport(
                  <AddComment
                    compId={'hashtags_hashtag_view_tweets_total_mentions'}
                    id={id}
                    {...report}
                  />,
                )}
                isReport={isReport}
                customFilters={currentHashtagId}
              />
            </ErrorBoundary>
          </Grid>
        ) : (
          <></>
        ),
    },
    {
      id: 'hashtags_hashtag_view_tweets_potential_reach',
      component:
        hashtag?.reach > 0 ? (
          <Grid
            item
            lg={checkIsReport(6, 3)}
            md={12}
            xl={checkIsReport(4, 2)}
            xs={checkIsReport(12, 6)}
          >
            <ErrorBoundary>
              <IconCard
                title={_t('hashtags:potential_reach')}
                hideInput
                cardData={{
                  icon: <UserNetworkIcon />,
                  count: hashtag.reach,
                }}
                compId="hashtags_hashtag_view_tweets_potential_reach"
                customFilters={currentHashtagId}
                hideIfNoData={hideCharts}
                additionalComponents={checkIsReport(
                  <AddComment
                    compId="hashtags_hashtag_view_tweets_potential_reach"
                    id={id}
                    {...report}
                  />,
                )}
                isReport={isReport}
              />
            </ErrorBoundary>
          </Grid>
        ) : (
          <></>
        ),
    },
    topLanguageChart({
      id: 'hashtags_hashtag_view_tweets_top_languages',
      title: _t('trends:Top_Languages'),
      subTitle: _t('influencers:tweets'),
      topLanguagesError: tweetTopLanguageError,
      topLanguages: tweetTopLanguages,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_tweets_influencers_entities_count',
      title: _t('hashtags:influencers_entities'),
      icon: <TotalInf />,
      slug: apiRoutes().twitterInfluencersEntities,
    }),
    sentimentChart({
      id: 'hashtags_hashtag_view_tweets_sentiment',
      title: _t('hashtags:sentiment_tweets'),
      subTitle: _t('influencers:tweets'),
      slug: apiRoutes().twitterSentiment,
    }),
    {
      id: 'hashtags_hashtag_view_tweets_world_map',
      component: hashtagTopCountries?.length ? (
        <Grid item lg={checkIsReport(12, 6)} md={12} xl={5} xs={12}>
          <ErrorBoundary requiredApiCalls={[hashtagTopCountriesError]}>
            <DotsMap
              title={`${hashtag?.hashtag_name} ${_t('trends:world_map')}`}
              data={hashtagTopCountries || []}
              page="view"
              expandAction={() =>
                history.push(
                  navigateWithSearchState(
                    hashtagTopCountries?.length
                      ? isTrendingModule
                        ? path.trends.TOP_COUNTRIES_WORLD_MAP
                        : path.hashtags.TOP_COUNTRIES_WORLD_MAP
                      : '',
                    {
                      data: apiRoutes().twitterTopCountries,
                      customFilters: {
                        hashtag_id: Number(id),
                        is_sample: isSample,
                      },
                      type: 'dots',
                      currentModule: 'hashtags',
                    },
                  ),
                )
              }
              currentModule="hashtags"
              compId="hashtags_hashtag_view_tweets_world_map"
              showToolTip
              additionalComponents={checkIsReport(
                <AddComment
                  compId="hashtags_hashtag_view_tweets_world_map"
                  id={id}
                  {...report}
                />,
              )}
              isReport={isReport}
            />
          </ErrorBoundary>
        </Grid>
      ) : (
        <></>
      ),
    },

    sentimentChart({
      id: 'hashtags_hashtag_view_tweets_Tweets_classification',
      title: _t('reports:tweets_classification'),
      subTitle: _t('influencers:tweets'),
      slug: apiRoutes().twitterClassification,
    }),
    {
      id: 'hashtags_hashtag_view_tweets_client_sources',
      component: (
        <Grid
          item
          lg={checkIsReport(6, 5)}
          md={12}
          xl={checkIsReport(4, 4)}
          xs={12}
        >
          <ErrorBoundary>
            <DonutChart
              exportIcon
              slug={apiRoutes().twitterClientSource}
              customFilters={currentHashtagId}
              showFilter={!sentmentError}
              sentmentError
              donutTitle={_t('hashtags:client_sources')}
              title={_t('influencers:tweets')}
              compId={'hashtags_hashtag_view_tweets_client_sources'}
              refetchCounter={reftechSentment}
              hideIfNoData
              additionalComponents={checkIsReport(
                <AddComment
                  compId={'hashtags_hashtag_view_tweets_client_sources'}
                  id={id}
                  {...report}
                />,
              )}
              isReport={isReport}
            />
          </ErrorBoundary>
        </Grid>
      ),
    },
    topInfluencerChart({
      id: 'hashtags_hashtag_view_tweets_top_influencer_entity',
      title: _t('trends:Top_Influencer_Entity'),
      slug: apiRoutes().twitterTopInfluencer,
    }),
    renderSecondaryTable({
      id: 'hashtags_hashtag_view_tweets_most_retweet_tweets',
      title: _t('hashtags:most_retweet_tweets'),
      slug: apiRoutes().twitterMostRetweetTweets,
      columns: RetweetColumns,
    }),

    renderSecondaryTable({
      id: 'hashtags_hashtag_view_tweets_most_favorited_tweets',
      title: _t('hashtags:most_favorited_tweets'),
      columns: FavoritColumns,
      slug: apiRoutes().twitterMostFavourite,
    }),
    {
      id: 'hashtags_hashtag_view_tweets_trending_list',
      component: hashtag?.is_trending ? (
        <Grid
          item
          lg={checkIsReport(12, 4)}
          md={12}
          xl={checkIsReport(6, 4)}
          xs={12}
        >
          <ErrorBoundary>
            <SecondaryTable
              tableCardTitle={_t('trends:trending_list')}
              hidePlatform
              hideFilters
              hideToggleView
              expandUrl={{
                pathname: isTrendingModule
                  ? path.trends.HASHTAGS
                  : path.hashtags.HASHTAGS,
                state: {
                  activeTab: 'trending',
                  option: {
                    label: hashtag?.hashtag_name,
                    value: +hashtag?.id,
                  },
                  pageName: 'hashtag_view',
                },
              }}
              expandUrlWithNavigate
              columns={trendingListColumns}
              moduleName={apiRoutes().trendingListHashtags}
              customFilters={{
                limit: 5,
                hashtag_id: +hashtag?.id,
                is_sample: isSample,
              }}
              compId="hashtags_hashtag_view_tweets_trending_list"
              hideIfNoData={hideCharts}
              additionalComponents={checkIsReport(
                <AddComment
                  compId="hashtags_hashtag_view_tweets_trending_list"
                  id={id}
                  {...report}
                />,
              )}
              isReport={isReport}
            />
          </ErrorBoundary>
        </Grid>
      ) : (
        <></>
      ),
    },
    {
      id: 'hashtags_hashtag_view_tweets_top_mentions_country',
      component: hashtagTopCountries?.length ? (
        <Grid
          item
          lg={checkIsReport(12, 3)}
          xl={checkIsReport(6, 5)}
          md={12}
          xs={12}
        >
          <ErrorBoundary requiredApiCalls={[hashtagTopCountriesError]}>
            <SecondaryTable
              tableCardTitle={_t('trends:top_mentions_country')}
              hideFilters
              notClickable
              hideToggleView
              columns={topCountriesColumns}
              data={sortArrayFromRecentToOlder(
                hashtagTopCountries?.slice(0, 5),
                'last_seen',
              )}
              expandUrlWithNavigate
              expandUrl={{
                pathname: isTrendingModule
                  ? path.trends.TOP_COUNTRIES_WORLD_MAP
                  : path.hashtags.TOP_COUNTRIES_WORLD_MAP,
                state: {
                  data: apiRoutes().hashtagTopCountries,
                  customFilters: {
                    hashtag_id: Number(id),
                    is_sample: isSample,
                  },
                  type: 'dots',
                  currentModule: 'hashtags',
                },
              }}
              currentModule="hashtags"
              compId="hashtags_hashtag_view_tweets_top_mentions_country"
              hideIfNoData={hideCharts}
              additionalComponents={checkIsReport(
                <AddComment
                  id={id}
                  compId="hashtags_hashtag_view_tweets_top_mentions_country"
                  {...report}
                />,
              )}
              isReport={isReport}
            />
          </ErrorBoundary>
        </Grid>
      ) : (
        <></>
      ),
    },
    renderSecondaryTable({
      id: 'hashtags_hashtag_view_tweets_most_valued_tweets',
      title: _t('hashtags:most_valued_tweets'),
      columns: ValuedTweetsColumns,
      slug: apiRoutes().twitterMostValuedTweets,
      xlGrid: 4,
      lgGrid: 4,
    }),
    renderSecondaryTable({
      id: 'hashtags_hashtag_view_tweets_top_mentions_links',
      title: _t('hashtags:top_mentions_links'),
      columns: topMentionedLinksColumns,
      slug: apiRoutes().twitterTopMentionedLinks,
      xlGrid: 4,
      lgGrid: 4,
    }),
    {
      id: 'hashtags_hashtag_view_tweets_type_of_tweets_media',
      component: notHasTweetMedia ? (
        <></>
      ) : (
        <Grid
          item
          lg={checkIsReport(6, 4)}
          md={12}
          xl={checkIsReport(6, 4)}
          xs={12}
        >
          <ErrorBoundary>
            <CustomColumnChart
              basicColumnTitle={_t('hashtags:type_of_tweets_media')}
              slug={apiRoutes().typeOfTweetsMedia}
              singleColumnChart
              clientSourceTooltip
              showToolTip
              withLegendCount
              distributed
              customFilters={memoizedTypeOFTweetsCustomFilters}
              compId="hashtags_hashtag_view_tweets_type_of_tweets_media"
              hideIfNoData={hideCharts}
              additionalComponents={checkIsReport(
                <AddComment
                  compId="hashtags_hashtag_view_tweets_type_of_tweets_media"
                  id={id}
                  {...report}
                />,
              )}
              isReport={isReport}
            />
          </ErrorBoundary>
        </Grid>
      ),
    },
    {
      id: 'hashtags_hashtag_view_tweets_top_mentions_images',
      component: (
        <ErrorBoundary>
          <SecondaryTable
            tableCardTitle={_t('hashtags:top_mentions_images')}
            hideFilters
            hideToggleView
            columns={topMentionedImagesColumns}
            moduleName={apiRoutes().topMentionedImage}
            customFilters={{
              limit: 5,
              hashtag_id: hashtag?.id,
              is_sample: isSample,
            }}
            compId="hashtags_hashtag_view_tweets_top_mentions_images"
            hideIfNoData={hideCharts}
            grid={{
              xs: 12,
              md: 12,
              lg: checkIsReport(12, 3),
              xl: checkIsReport(6),
            }}
            additionalComponents={checkIsReport(
              <AddComment
                compId="hashtags_hashtag_view_tweets_top_mentions_images"
                id={id}
                {...report}
              />,
            )}
            isReport={isReport}
          />
        </ErrorBoundary>
      ),
    },

    {
      id: 'hashtags_hashtag_view_tweets_mentions',
      component:
        hashtag?.is_trending || isReport ? (
          <Grid
            item
            lg={checkIsReport(12, 6)}
            xl={checkIsReport(12, 6)}
            md={12}
            xs={12}
          >
            <ErrorBoundary>
              <CustomColumnChart
                basicColumnTitle={_t('trends:Mentions')}
                slug={apiRoutes().twitterMentionsChart}
                customFilters={memoizedMentionsCustomFilters}
                timeIntervalFilter={hideCharts}
                monthTimeIntervalWithoutDay
                mentionsTooltip
                showToolTip
                compId="hashtags_hashtag_view_tweets_mentions"
                hideIfNoData={hideCharts}
                additionalComponents={checkIsReport(
                  <AddComment
                    compId="hashtags_hashtag_view_tweets_mentions"
                    id={id}
                    {...report}
                  />,
                )}
                isReport={isReport}
              />
            </ErrorBoundary>
          </Grid>
        ) : (
          <></>
        ),
    },
    firstMentionChart({
      id: 'hashtags_hashtag_view_tweets_first_mention',
      title: _t('hashtags:first_mention_tweet'),
      firstMentionData: firstMentionDataTwitter || firstMentionData,
      firstMentionError: firstMentionErrorTwitter || firstMentionError,
      currentPlatform: 'twitter',
    }),
  ];

  const instagram: TRenderCharts = [
    TotalChart({
      id: 'hashtags_hashtag_view_instagram_posts_total_posts',
      title: _t('hashtags:total_posts'),
      icon: <InstagramBigIcon />,
      count: hashtag?.instagram_posts_count,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_instagram_posts_engagement',
      title: _t('trends:engagement'),
      icon: <TrendingIcon />,
      slug: apiRoutes().instagramEngagement,
    }),
    sentimentChart({
      id: 'hashtags_hashtag_view_instagram_posts_sentiment',
      title: _t('hashtags:sentiment_instagram'),
      subTitle: _t('influencers:posts'),
      slug: apiRoutes().instagramSentimentPosts,
    }),
    topLanguageChart({
      id: 'hashtags_hashtag_view_instagram_posts_top_languages',
      title: _t('trends:Top_Languages'),
      subTitle: _t('influencers:posts'),
      topLanguagesError: instagramTopLanguageError,
      topLanguages: instagramTopLanguages,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_instagram_posts_influencers_entities_count',
      title: _t('hashtags:influencers_entities'),
      icon: <TotalInf />,
      slug: apiRoutes().instagramInfluencersEntities,
    }),
    renderSecondaryTable({
      id: 'hashtags_hashtag_view_instagram_posts_top_influencer_entity',
      title: _t('trends:Top_Influencer_Entity'),
      slug: apiRoutes().instagramTopInfluencer,
      columns: influencersColumns,
      xlGrid: 3,
    }),
    renderSecondaryTable({
      id: 'hashtags_hashtag_view_instagram_posts_most_favorited_posts',
      title: _t('hashtags:most_favorited_posts'),
      columns: favouritPostColumns,
      slug: apiRoutes().instagramMostFavourite,
    }),

    firstMentionChart({
      id: 'hashtags_hashtag_view_instagram_posts_first_mention',
      title: _t('hashtags:first_mention_post'),
      firstMentionData: firstMentionDataInstagram || firstMentionData,
      firstMentionError: firstMentionErrorInstagram || firstMentionError,
      currentPlatform: 'instagram',
    }),
  ];
  const linkedin: TRenderCharts = [
    TotalChart({
      id: 'hashtags_hashtag_view_linkedin_posts_total_posts',
      title: _t('hashtags:total_posts'),
      icon: <LinkedinBigIcon />,
      count: hashtag?.linkedin_posts_count,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_linkedin_posts_engagement',
      title: _t('trends:engagement'),
      icon: <TrendingIcon />,
      slug: apiRoutes().linkedinEngagement,
    }),
    sentimentChart({
      id: 'hashtags_hashtag_view_linkedin_posts_sentiment',
      title: _t('hashtags:sentiment_linkedin'),
      subTitle: _t('influencers:posts'),
      slug: apiRoutes().linkedinSentimentPosts,
    }),
    topLanguageChart({
      id: 'hashtags_hashtag_view_linkedin_posts_top_languages',
      title: _t('trends:Top_Languages'),
      subTitle: _t('influencers:posts'),
      topLanguagesError: linkedinTopLanguageError,
      topLanguages: linkedinTopLanguages,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_linkedin_posts_influencers_entities_count',
      title: _t('hashtags:influencers_entities'),
      icon: <TotalInf />,
      slug: apiRoutes().linkedinInfluencersEntities,
    }),
    topInfluencerChart({
      id: 'hashtags_hashtag_view_linkedin_posts_top_influencer_entity',
      title: _t('trends:Top_Influencer_Entity'),
      slug: apiRoutes().linkedinTopInfluencer,
    }),
    renderSecondaryTable({
      id: 'hashtags_hashtag_view_linkedin_posts_most_engaged_posts',
      title: _t('hashtags:most_engaged_posts'),
      columns: engagedPostColumns,
      slug: apiRoutes().linkedinMostFavourite,
    }),
    firstMentionChart({
      id: 'hashtags_hashtag_view_linkedin_posts_first_mention',
      title: _t('hashtags:first_mention_post'),
      firstMentionData: firstMentionDataLinkedIn || firstMentionData,
      firstMentionError: firstMentionErrorLinkedIn || firstMentionError,
      currentPlatform: 'linkedin',
    }),
  ];
  const youtube: TRenderCharts = [
    TotalChart({
      id: 'hashtags_hashtag_view_youtube_videos_total_videos',
      title: _t('hashtags:total_videos'),
      icon: <VideoBigIcon />,
      count: hashtag?.youtube_videos_count,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_youtube_videos_engagement',
      title: _t('trends:engagement'),
      icon: <TrendingIcon />,
      slug: apiRoutes().videosEngagement,
    }),
    sentimentChart({
      id: 'hashtags_hashtag_view_youtube_videos_sentiment',
      title: _t('hashtags:sentiment_videos'),
      subTitle: _t('basic:videos'),
      slug: apiRoutes().videosSentiment,
    }),
    topLanguageChart({
      id: 'hashtags_hashtag_view_youtube_videos_top_languages',
      title: _t('trends:Top_Languages'),
      subTitle: _t('basic:videos'),
      topLanguagesError: videosTopLanguageError,
      topLanguages: videosTopLanguages,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_youtube_videos_influencers_entities_count',
      title: _t('hashtags:influencers_entities'),
      icon: <TotalInf />,
      slug: apiRoutes().videosInfluencersEntities,
    }),
    topInfluencerChart({
      id: 'hashtags_hashtag_view_youtube_videos_top_influencer_entity',
      title: _t('trends:Top_Influencer_Entity'),
      slug: apiRoutes().videosTopInfluencer,
    }),
    renderSecondaryTable({
      id: 'hashtags_hashtag_view_youtube_videos_most_viewed_videos',
      title: _t('hashtags:most_viewed_videos'),
      columns: mostViewedVideoColumns,
      slug: apiRoutes().videosMostViewed,
    }),
    renderSecondaryTable({
      id: 'hashtags_hashtag_view_youtube_videos_most_favorited_videos',
      title: _t('hashtags:most_favourite_videos'),
      columns: favouritvideosColumns,
      slug: apiRoutes().videosMostFavourite,
    }),
    firstMentionChart({
      id: 'hashtags_hashtag_view_youtube_videos_first_mention',
      title: _t('hashtags:first_mention_videos'),
      firstMentionData: firstMentionDataYoutube || firstMentionData,
      firstMentionError: firstMentionErrorYoutube || firstMentionError,
      currentPlatform: 'youtube',
    }),
  ];
  const tiktok: TRenderCharts = [
    TotalChart({
      id: 'hashtags_hashtag_view_tiktok_videos_total_videos',
      title: _t('hashtags:total_videos'),
      icon: <VideoBigIcon />,
      count: hashtag?.tiktok_posts_count,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_tiktok_videos_engagement',
      title: _t('trends:engagement'),
      icon: <TrendingIcon />,
      slug: apiRoutes().tiktokEngagement,
    }),
    sentimentChart({
      id: 'hashtags_hashtag_view_tiktok_videos_sentiment',
      title: _t('hashtags:sentiment_videos'),
      subTitle: _t('basic:videos'),
      slug: apiRoutes().tiktokSentiment,
    }),
    topLanguageChart({
      id: 'hashtags_hashtag_view_tiktok_videos_top_languages',
      title: _t('trends:Top_Languages'),
      subTitle: _t('basic:videos'),
      topLanguagesError: tiktokTopLanguageError,
      topLanguages: tiktokTopLanguages,
    }),
    TotalChart({
      id: 'hashtags_hashtag_view_tiktok_videos_influencers_entities_count',
      title: _t('hashtags:influencers_entities'),
      icon: <TotalInf />,
      slug: apiRoutes().tiktokInfluencersEntities,
    }),
    topInfluencerChart({
      id: 'hashtags_hashtag_view_tiktok_videos_top_influencer_entity',
      title: _t('trends:Top_Influencer_Entity'),
      slug: apiRoutes().tiktokTopInfluencer,
    }),
    renderSecondaryTable({
      id: 'hashtags_hashtag_view_tiktok_videos_most_viewed_videos',
      title: _t('hashtags:most_viewed_videos'),
      columns: tiktokMostViewedColumns,
      slug: apiRoutes().tiktokMostViewed,
    }),
    renderSecondaryTable({
      id: 'hashtags_hashtag_view_tiktok_videos_most_favorited_videos',
      title: _t('hashtags:most_favourite_videos'),
      columns: tiktokFavoriteVideosColumns,
      slug: apiRoutes().tiktokMostFavorite,
    }),
    firstMentionChart({
      id: 'hashtags_hashtag_view_tiktok_videos_first_mention',
      title: _t('hashtags:first_mention_videos'),
      firstMentionData: firstMentionDataTiktok || firstMentionData,
      firstMentionError: firstMentionErrorTiktok || firstMentionError,
      currentPlatform: 'tiktok',
    }),
  ];
  const renderCharts = {
    summary,
    twitter,
    youtube,
    instagram,
    linkedin,
    tiktok,
  };
  const renderPage = () => {
    if (items) {
      const paragraph = items?.map((item) =>
        extractTitleOrSubTileOrReportNameOrDesc(item),
      );
      const chartsFilter = Object.values(renderCharts)
        .flat()
        .map((item) =>
          items?.some((i: any) => i?.slug === item?.id)
            ? {
                ...item,
                order: items?.find((comp) => comp.slug === item.id)?.order,
              }
            : null,
        );

      return [...chartsFilter, ...paragraph]
        .filter(Boolean)
        .sort((a, b) => a.order - b.order)
        .map((item) => item.component);
    }

    if (isReport && report)
      return report?.renderCharts(Object.values(renderCharts).flat());

    return renderCharts?.[tabName!]?.map((item) => {
      const Component = item.component;
      if (Component) return React.cloneElement(Component, { key: item?.id });
    });
  };

  return hashtagLoading ? <Loader /> : <>{renderPage()}</>;
};

export default HashtagDetailsCharts;
